import { render } from "./itemli.vue?vue&type=template&id=15a4c169&scoped=true"
import script from "./itemli.vue?vue&type=script&lang=js"
export * from "./itemli.vue?vue&type=script&lang=js"

import "./itemli.vue?vue&type=style&index=0&id=15a4c169&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a4c169"]])

export default __exports__